"use client";

import React, { useState } from "react";
import "swiper/css";
import "swiper/css/pagination";
import { motion } from "framer-motion";
import Testimonials from "@/component/Testimonials";
import SecurityAssurance from "@/component/SecurityAssurance";
import { GoldOnlineSection } from "@/component/GoldOnlineSection";
import { WhyChooseBuySection } from "@/component/WhyChooseBuySection";
import { AppDownloadSection } from "@/component/AppDownloadSection";

import TrustedStats from "@/component/TrustedStats";
import ServicesCTA from "@/component/ServicesCTA";

const SellService = () => {
  return (
    <div className="flex flex-col min-h-screen w-full">
      <section className="py-16 px-4 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto">
          {/* Title */}
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-4"
          >
            <h2
                className="text-4xl md:text-[48px] font-semibold tracking-[-1px] lg:w-full leading-[1.25] md:mb-4 lg:mb-4 text-primary"
                style={{ lineHeight: 1.1 }}
              >
              Sell 24K Gold in 3 Simple Steps
            </h2>
             <p className="text-base md:text-lg mb-6 md:mb-8 text-[#57575c]">
              Start from AED 10. Fully backed, insured, and stored in secure UAE
              vaults.
            </p>
          </motion.div>

          {/* Steps Container */}
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
            {/* Step 1 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.5 }}
              className="flex flex-col items-center"
            >
              <div className="relative mb-6">
                <div className="bg-white rounded-2xl shadow-lg p-6 max-w-sm">
                  <img
                    src="/sell/step1.svg"
                    alt="Choose Your Gold"
                    className="w-full"
                  />
                </div>
              </div>
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-blue-900 text-white mb-4">
                1
              </div>
              <h3 className="text-xl text-primary font-semibold mb-2">Select Gold & View Live Rate</h3>
               <p className="text-[#57575c] text-center text-md">
                Choose the amount of gold you want to sell and confirm the live market price in real time.
                
              </p>
            </motion.div>

            {/* Step 2 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6, duration: 0.5 }}
              className="flex flex-col items-center"
            >
              <div className="relative mb-6">
                <div className="bg-white rounded-2xl shadow-lg p-6 max-w-sm">
                  <img
                    src="/sell/step2.svg"
                    alt="Make Secure Payment"
                    className="w-full"
                  />
                </div>
              </div>
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-blue-900 text-white mb-4">
                2
              </div>
              <h3 className="text-xl text-primary font-semibold mb-2">Choose Your Payout Method</h3>
               <p className="text-[#57575c] text-center text-md">
                Select where you want your money credited. Bank account or preferred payment option.
              </p>
            </motion.div>

            {/* Step 3 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.9, duration: 0.5 }}
              className="flex flex-col items-center"
            >
              <div className="relative mb-6">
                <div className="bg-white rounded-2xl shadow-lg p-6 max-w-sm">
                  <img
                    src="/sell/step3.svg"
                    alt="Gold Added to Your Vault"
                    className="w-full"
                  />
                </div>
              </div>
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-blue-900 text-white mb-4">
                3
              </div>
              <h3 className="text-xl text-primary font-semibold mb-2">Gold Sold Successfully</h3>
               <p className="text-[#57575c] text-center text-md">
                Your sale is confirmed instantly.
              </p>
            </motion.div>
          </div>
        </div>
      </section>
     
       <TrustedStats />
       
      <SecurityAssurance />
      <GoldOnlineSection type="Sell"/>
      <WhyChooseBuySection/>
      <AppDownloadSection type="Sell"/>
      <Testimonials />
      <ServicesCTA />
      
      
    </div>
  );
};

export default SellService;
